import { makeStyles } from '@mui/styles';
import { COLORS } from '../../shared/config/colors';

const styles = makeStyles(() => ({
  logo: {
    width: '300px',
  },
  divider: {
    marginTop: '10px',
    marginBottom: '20px',
    width: '100%',
  },
  text: {
    marginBottom: '2%',
    textAlign: 'center'
  },
  link: {
    marginTop: '10%',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  orderText: {
    fontSize: '36px',
    color: COLORS.BLUE,
    padding: '16px',
    textAlign: 'center',
  },
  actionButton: {
    fontSize: '36px',
    color: COLORS.BLUE,
    padding: '16px',
    '&:hover': {
      textDecoration: 'underline',
    },
    textAlign: 'center',
    cursor: 'pointer'
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    border: `1px solid ${COLORS.GRAY}`,
    borderRadius: '10px',
    padding: '30px',
    width: '600px',
    fontSize: '30px',
    margin: '5% 0'
  }
}));

export default styles;
